import { client } from "utils/axios";
import * as yup from "yup";

/* ─────────────────────────────────────────────
   NUEVO: insumo-complete  (variant + movement)
───────────────────────────────────────────── */
export async function getAllInsumoComplete() {
  const { data } = await client.get("/inventory-movements");
  return data;
}

export const createInsumoComplete = async (payload, dispatch) => {
  const { showMessage } = await import("store/modules/Message");
  try {
    await client.post("insumo-complete", payload);
    dispatch(showMessage({ message: "Registro creado con éxito", variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }));
    return true;
  } catch (error) {
    dispatch(showMessage({ message: error?.response?.data?.message || "Error al crear el registro", variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }));
    return false;
  }
};

export const modifyInsumoComplete = async (payload, dispatch) => {
  const { showMessage } = await import("store/modules/Message");
  try {
    await client.put("insumo-complete", payload);
    dispatch(showMessage({ message: "Registro actualizado con éxito", variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }));
    return true;
  } catch (error) {
    dispatch(showMessage({ message: error?.response?.data?.message || "Error al actualizar el registro", variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }));
    return false;
  }
};

export const deleteInsumoComplete = async (id, dispatch) => {
  const { showMessage } = await import("store/modules/Message");
  try {
    await client.delete(`insumo-complete/${id}`);
    dispatch(showMessage({ message: "Registro eliminado con éxito", variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }));
    return true;
  } catch (error) {
    dispatch(showMessage({ message: error?.response?.data?.message || "Error al eliminar el registro", variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }));
    return false;
  }
};

export const deleteVariantAttribute = async (id) => {
  await client.delete(`variant-attributes/${id}`);
};

/* ─────────────────────────────────────────────
   LEGACY: inventory-movements (se mantiene)
───────────────────────────────────────────── */

export async function getMovementsByInsumo(insumoId) {
  const { data } = await client.get(`/inventory-movements/insumo/${insumoId}`);
  return data;
}

export async function getMovementsByTipo(tipo) {
  const { data } = await client.get(`/inventory-movements/tipo/${tipo}`);
  return data;
}

export const createMovement = async (movement) => {
  try {
    await client.post("/inventory-movements", movement);
  } catch (error) {
    console.log(error);
  }
};

export const modifyMovement = async (movement) => {
  try {
    await client.put("/inventory-movements", movement);
  } catch (error) {
    console.log(error);
  }
};

export const deleteMovement = async (id) => {
  await client.delete(`/inventory-movements/${id}`);
};

/**
 * Recalcula el stock de un insumo leyendo TODOS sus movimientos
 * en orden cronológico y aplica la lógica:
 *   ENTRADA → suma
 *   SALIDA  → resta (nunca baja de 0)
 *   AJUSTE  → reemplaza el acumulado directamente
 *
 * Luego persiste el nuevo valor en el campo `stack` del insumo.
 * @param {number} insumoId
 * @returns {number} nuevo stock calculado
 */
export const updateInsumoStack = async (insumoId) => {
  // 1. Obtener movimientos frescos del servidor
  const movimientos = await getMovementsByInsumo(insumoId);

  // 2. Ordenar cronológicamente y calcular stock
  const ordenados = [...(movimientos || [])].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );

  let total = 0;
  for (const m of ordenados) {
    const qty = parseFloat(m.quantity) || 0;
    switch (m.movementType) {
      case "ENTRADA":
        total += qty;
        break;
      case "SALIDA":
        total = Math.max(0, total - qty);
        break;
      case "AJUSTE":
        total = qty;
        break;
      default:
        break;
    }
  }
  const newStack = parseFloat(Math.max(0, total).toFixed(2));

  // 3. Obtener el insumo completo para no perder ningún campo
  const { data: insumo } = await client.get(`/insumos/${insumoId}`);

  // 4. Actualizar solo el campo stack y persistir
  await client.put("/insumos", { ...insumo, stack: newStack });

  return newStack;
};

export const validationSchemaMovement = yup.object({
  insumoId: yup.number().typeError("Selecciona un insumo").required("Campo requerido"),
  sku: yup.string().required("SKU requerido"),
  movementType: yup.string().required("Tipo de movimiento requerido"),
  quantity: yup
    .number()
    .typeError("Debe ser un número")
    .required("Campo requerido"),
  unit: yup.string(),
});

